import { createFileRoute, redirect } from '@tanstack/react-router';

// Codebase analytics was removed; old links and bookmarks land on Sources
// instead of the 404 page.
export const Route = createFileRoute('/$organizationName/settings/analytics')({
  component: () => null,
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/$organizationName/sources',
      params: { organizationName: params.organizationName },
    });
  },
});
